import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { AutenticacionService } from '../../services/autenticacion.service';
import { RespuestaGenerica } from 'src/app/models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { Operaciones_Reembolso_Lista } from 'src/app/models/generic/Operaciones_Reembolso_Lista';
import { Operaciones_ReembolsoService } from 'src/app/services/operaciones_reembolso.service';
import { Listas } from 'src/app/models/generic/Listas';
import { OperacionesReembolsoActualizarComponent } from '../operaciones-reembolso-actualizar/operaciones-reembolso-actualizar.component';

@Component({
  selector: 'operaciones-reembolso',
  templateUrl: './operaciones-reembolso.component.html',
  styleUrls: ['./operaciones-reembolso.component.scss']
})
export class OperacionesReembolsoComponent implements OnInit{
  TIPO_CONFIRMACION_ANULAR: string = 'ANULAR';
  TIPO_CONFIRMACION_PROCESAR: string = 'PROCESAR';
  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('appoperacionesreembolso', {static: false}) _appoperacionesreembolso: OperacionesReembolsoActualizarComponent;
  dataSource: MatTableDataSource<Operaciones_Reembolso_Lista>;
  columnasEncabezado: string[] = ['expediente', 'fechaCreacion', 'descripcionEstado', 'afiliado', 'cliente', 'programa', 'gestiono', 'cierre', 'acciones'];
  listaDatos: Operaciones_Reembolso_Lista[] = [];
  itemSeleccionado: Operaciones_Reembolso_Lista;
  listasCompletas: Listas[] = [];
  listasAliados: Listas[] = [];
  listasProductos: Listas[] = [];
  tipoConfirmacion: string = '';
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Operaciones_ReembolsoService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.ConsultarListas();
    this.ConsultarRegistros();
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      idAliado: [0],
      idProducto: [0],
      expediente: ['']
    });
  }
  ConsultarRegistros() {
    this.mostrarCargando = true;
    this.datosServices.Consultar(this.form.value)
              .subscribe((resp: Operaciones_Reembolso_Lista[]) =>{
                this.mostrarCargando = false;
                this.listaDatos = resp;
                this.datosServices.ListaOperacionesReembolso = resp;
                this.recargarLista();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }
  recargarLista() {
    this.dataSource = new MatTableDataSource(this.listaDatos);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  eliminarDetalle(itemSeleccionado: Operaciones_Reembolso_Lista) {
    this.itemSeleccionado = itemSeleccionado;
    this.tipoConfirmacion = this.TIPO_CONFIRMACION_ANULAR;
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  procesarDetalle(itemSeleccionado: Operaciones_Reembolso_Lista) {
    this.itemSeleccionado = itemSeleccionado;
    this.tipoConfirmacion = this.TIPO_CONFIRMACION_PROCESAR;
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  editarDetalle(itemSeleccionado: Operaciones_Reembolso_Lista) {
    this._appoperacionesreembolso.EditarAbrirModal(itemSeleccionado);
  }

  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.tipoConfirmacion === this.TIPO_CONFIRMACION_ANULAR) {
        this.EliminarRegistro();      
      } else if (this.tipoConfirmacion === this.TIPO_CONFIRMACION_PROCESAR) {
        this.ActualizarEstadoRegistro();      
      }
    }
  }
  EliminarRegistro() {
    this.mostrarCargando = true;
    this.datosServices.Eliminar(this.itemSeleccionado)
            .subscribe((resp: RespuestaGenerica) =>{
              this.mostrarCargando = false;
              if (resp.procesoExitoso == false) {
                this.utilitariosService.MensajeToast(resp.mensaje);
              } else {
                this.ConsultarRegistros();
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ActualizarEstadoRegistro() {
    this.mostrarCargando = true;
    this.itemSeleccionado.estado = 'PRO';
    this.datosServices.ActualizarEstado(this.itemSeleccionado)
            .subscribe((resp: RespuestaGenerica) =>{
              this.mostrarCargando = false;
              if (resp.procesoExitoso == false) {
                this.utilitariosService.MensajeToast(resp.mensaje);
              } else {
                this.ConsultarRegistros();
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarListas() {
    this.mostrarCargando = true;
    this.datosServices.ConsultarListas()
              .subscribe((resp: Listas[]) =>{
                this.mostrarCargando = false;
                this.listasCompletas = resp;
                this.listasAliados = this.listasCompletas.filter(x => x.lista === 'ALIADOS');
                this.mostrarCargando = false;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  Cambio_Aliado() {
    this.RecargarListaProductos();
  }
  RecargarListaProductos() {
    this.listasProductos = this.listasCompletas.filter(x => x.lista === 'MAESTRO_PRODUCTOS' && x.dependienciaId === this.form.get('idAliado').value);

    if (this.listasProductos.length === 1) {
      this.form.get('idProducto').setValue(this.listasProductos[0].id);
    }
  }
  TerminoGuardarOperacionesReembolso() {
    this.ConsultarRegistros();
  }
  ItemEstadoPendiente(itemSeleccionado: Operaciones_Reembolso_Lista): boolean {
    return itemSeleccionado.estado === 'PEN' && this.menuService.TienePermisoEscrituraEnMenu('OperacionesReembolsoComponent');
  }
  TituloOpcionMenu(): string {
    return this.menuService.ObtenerTituloOpcionComponente('OperacionesReembolsoComponent');
  }
}
